import { useEffect } from 'react';
import './Popup.css';

const Popup = ({ popup, setPopup }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById('body').classList.add('modal-open');
        sessionStorage.setItem('shownPopup', '1');
    }, []);

    const closeModal = () => {
        document.getElementById('body').classList.remove('modal-open');
        setPopup('');
    };

    return (
        <div
            className="popup-v2-backdrop"
            onClick={closeModal}
            role="presentation"
        >
            <div
                className="popup-v2-dialog"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="popup-v2-eyebrow"
            >
                <div className="popup-v2-accent" aria-hidden />
                <p id="popup-v2-eyebrow" className="popup-v2-eyebrow">
                    Before you order
                </p>
                <p className="popup-v2-body">{popup}</p>
                <button
                    type="button"
                    className="popup-v2-cta"
                    onClick={closeModal}
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

export default Popup;
